export enum MethodPaymentAccessTypeEnum {
    PIX = 'PIX',
    EMAIL = 'EMAIL',
    TELEFONE = 'TELEFONE',
    CHAVE_ALEATORIA = 'CHAVE ALEATÓRIA',
}
